import React, { useState } from 'react';

import classNames from 'classnames';
import { get } from 'lodash';

import { PASSWORD_INPUT, SINGLE_CHARACTER } from '../../constants';

import inputPasswordIconEye from './input-password-icon-eye.svg';

import './input.scss';

export interface IInputProps {
  className?: string;
  onChange?: (value: string) => void;
}

export type CleanHTMLInputPropsType = Omit<
  React.HTMLProps<HTMLInputElement>,
  'onChange'
>;

const Input = React.forwardRef<
  HTMLInputElement,
  IInputProps & CleanHTMLInputPropsType
>(
  (
    {
      type,
      name,
      placeholder,
      className = '',
      onKeyDown,
      value,
      onChange,
      onBlur,
      disabled,
    },
    ref
  ) => {
    const [isPasswordVisible, setPasswordVisibility] = useState(false);
    const passwordInputType = isPasswordVisible ? 'text' : PASSWORD_INPUT;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      // const { value: inputValue } = e.target as HTMLInputElement;
      const inputValue: string = get(e, 'target.value', '');
      onChange && onChange(inputValue);
    };

    return (
      <div
        className={classNames('input', {
          'input-password': type === PASSWORD_INPUT,
          'input--one-char': type === SINGLE_CHARACTER,
          [className]: !!className,
        })}
        // @ts-ignore // TODO: fiw TS error saying current is not a propery
        onClick={() => ref && ref.current && ref.current.focus()}
      >
        <input
          type={type === PASSWORD_INPUT ? passwordInputType : type}
          name={name}
          id={name}
          placeholder={placeholder}
          className="input__input"
          onKeyDown={onKeyDown}
          onChange={handleChange}
          onBlur={onBlur}
          value={value}
          disabled={disabled}
          ref={ref}
        />

        {type === PASSWORD_INPUT && (
          <button
            className="input-password-btn"
            onClick={() => setPasswordVisibility(!isPasswordVisible)}
            type="button"
          >
            <img src={inputPasswordIconEye} alt="icon eye" />
          </button>
        )}
      </div>
    );
  }
);

Input.defaultProps = {
  type: 'text',
  name: '',
  placeholder: '',
};

export default Input;
